import { render } from "./MUrl.vue?vue&type=template&id=42d5aaef&scoped=true&ts=true"
import script from "./MUrl.vue?vue&type=script&lang=ts"
export * from "./MUrl.vue?vue&type=script&lang=ts"

import "./MUrl.vue?vue&type=style&index=0&id=42d5aaef&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/campaign-widget/campaign-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42d5aaef"]])

export default __exports__